import React, { useEffect, useState } from 'react';
import { SidePage, Button } from '@gogame/components';
import { FormField, withForm } from '@gogame/form';
import { InnerComponent } from './InnerComponent';

const ErrorDetails = withForm({
  enableReinitialize: true,
})(({ onClose, onExited, open }) => {
  const [data, setData] = useState({user: {name: 'name'}});


  const handleRenderError = () => {
    setData([]);
  }
  return (
    <SidePage
      backdrop={false}
      onClose={onClose}
      onExited={onExited}
      loading={false}
      fetching={false}
      open={open}
      size={'lg'}
    >
      <SidePage.Title title={'title'} subTitle={'Subtitle'} entityId={`1234`} />
      <SidePage.NewBody>
        {data.user.name}
        <Button onClick={handleRenderError}>Generate render Error</Button>


        <FormField.Select
          label={'My Select'}
          padding={'0'}
          name={'mySelect'}
          source={async () => ([{id:1, name: 'test'}, {id:1, name: 'test2'}, null])}
          lazy={true}
        />
        <h5>Inner component:</h5>
        <InnerComponent />
      </SidePage.NewBody>
      <SidePage.Actions>
        <SidePage.CloseButton />
      </SidePage.Actions>
    </SidePage>
  );
});

export default ErrorDetails;
